import{useState as r,useEffect as e}from"react";
/**
 * 1回のアニメーション周期が完了するまでの所要時間よりもアンマウント時間は短く設定する
 * @example
 * - animation-duration : 250s
 * - unMountTime : 240s
 */var t=(t,a)=>{var[i,o]=r(t);return e((()=>{
/** 表示時の処理 */
if(!t){
/** 非表示時の処理、アニメーション実行後dom破棄 */
var r=null!=a?a:250,e=window.setTimeout((()=>o(t)),r);return()=>clearTimeout(e)}o(t)}),[t]),{display:i}};export{t as useFade};
